import { combineReducers } from "redux"

const initialState = {}

const inventoryReducer = (state = initialState, action) => {
    switch(action['type']){
        case 'GET_INVENTORY_DATA':
            state['inventoryData'] = action['payload']
            return state
        default: 
            return state
    }
}

const rootReducer = combineReducers({
    inventoryReducer
})

export default rootReducer